import {BewerbTeam} from "@/services/data/meisterschaften/bewerbTeam";

export class BewerbTeamDouble extends BewerbTeam {
    constructor(team, id, isTeamForSpiel) {
        super(team, id, 'doppel', isTeamForSpiel);
    }

    fillSettingsFromPlayer() {
        const player1 = this.settings.player1
        const player2 = this.settings.player2
        this.settings.name = player1.nachname + ' ' + player1.vorname + ' / ' + player2.nachname + ' ' + player2.vorname
        this.settings.vereinsName = player1.verein !== player2.verein ? player1.verein + ' / ' + player2.verein : player1.verein
        this.settings.landesverband = player1.landesverband !== player2.landesverband ?
                                player1.landesverband + ' / ' + player2.landesverband : player1.landesverband
        this.settings.ak = player1.ak !== player2.ak ? player1.ak + ' / ' + player2.ak : player1.ak
    }
}